import { render, staticRenderFns } from "./DeviceMappingComponent.vue?vue&type=template&id=23714e8e&"
import script from "./DeviceMappingComponent.vue?vue&type=script&lang=js&"
export * from "./DeviceMappingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports